import React, { useState, useEffect, useCallback, useRef } from 'react';
import './App.css';
import ChatPanel from './components/ChatPanel';
import ModelViewer from './components/ModelViewer';
import { getCurrentModel, resetWorkspace } from './services/api';

function App() {
  const [modelUrl, setModelUrl] = useState(null);
  const [stepUrl, setStepUrl] = useState(null);
  const [parts, setParts] = useState([]);
  const [featureTree, setFeatureTree] = useState([]);
  const [bodyMeshes, setBodyMeshes] = useState([]);
  const [selectedBody, setSelectedBody] = useState(null);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const selectionRef = useRef({ body: null, feature: null });
  const [authenticated, setAuthenticated] = useState(!!sessionStorage.getItem('access_password'));
  const [passwordInput, setPasswordInput] = useState('');

  const handleFeatureSelect = useCallback((bodyName, featureName) => {
    const newFeat = featureName || null;
    const cur = selectionRef.current;
    if (bodyName === cur.body && newFeat === cur.feature) {
      // Toggle off
      selectionRef.current = { body: null, feature: null };
      setSelectedBody(null);
      setSelectedFeature(null);
    } else {
      selectionRef.current = { body: bodyName, feature: newFeat };
      setSelectedBody(bodyName);
      setSelectedFeature(newFeat);
    }
  }, []);

  useEffect(() => {
    if (!authenticated) return;
    getCurrentModel()
      .then(data => {
        setModelUrl(data.model_url || null);
        setStepUrl(data.step_url || null);
        setParts(data.parts || []);
        setFeatureTree(data.feature_tree || []);
        setBodyMeshes(data.body_meshes || []);
      })
      .catch(() => console.log('No existing model'));
  }, [authenticated]);

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordInput.trim()) {
      sessionStorage.setItem('access_password', passwordInput.trim());
      setAuthenticated(true);
    }
  };

  const handleModelUpdate = (url, stepFileUrl, partsList, tree, meshes) => {
    setModelUrl(url);
    setStepUrl(stepFileUrl || null);
    setParts(partsList || []);
    setFeatureTree(tree || []);
    setBodyMeshes(meshes || []);
  };

  const handleReset = async () => {
    await resetWorkspace();
    setModelUrl(null);
    setStepUrl(null);
    setParts([]);
    setFeatureTree([]);
    setBodyMeshes([]);
    setSelectedBody(null);
    setSelectedFeature(null);
    selectionRef.current = { body: null, feature: null };
  };

  if (!authenticated) {
    return (
      <div className="App login-screen">
        <form onSubmit={handlePasswordSubmit} className="login-form">
          <h1 className="login-title">Agentic CAD</h1>
          <p className="login-subtitle">Enter the access password to continue</p>
          <div className="login-input-row">
            <input
              type="password"
              value={passwordInput}
              onChange={(e) => setPasswordInput(e.target.value)}
              placeholder="Password"
              autoFocus
              className="login-input"
            />
            <button type="submit" className="login-button">Enter</button>
          </div>
        </form>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-content">
          <h1>Agentic CAD</h1>
          <span className="separator">|</span>
          <p className="subtitle">Create 3D models with AI</p>
        </div>
      </header>
      <div className="main-container">
        <ChatPanel onModelUpdate={handleModelUpdate} onReset={handleReset} selectedBody={selectedBody} selectedFeature={selectedFeature} />
        <ModelViewer modelUrl={modelUrl} stepUrl={stepUrl} parts={parts} featureTree={featureTree} bodyMeshes={bodyMeshes} selectedBody={selectedBody} selectedFeature={selectedFeature} onFeatureSelect={handleFeatureSelect} />
      </div>
    </div>
  );
}

export default App;
